import React, {useEffect} from 'react';
import {useStore} from '@/app/providers/StoreProvider';
import {Loading} from '@/shared/ui/Loading';
import FonbetNew from '@/shared/pictures/fonbet_new.png';

import {Link} from 'react-router';

import {ProfileUserWidget} from "@/widgets/profile/ProfileUserWidget";
import {ProfileFriendWidget} from "@/widgets/profile/ProfileFriendsWidget";
import {ProfileStatisticWidget} from "@/widgets/profile/ProfileStatisticWidget";
import {ProfileGoldPuckWidget} from "@/widgets/profile/ProfileGoldPuckWidget";

export const ProfilePage = () => {

    const {userStore} = useStore();
    useEffect(() => {
        const fetchGameInfo = async () => {
            await userStore.getGameInfo();
        }
        const fetchData = async () => {
            await userStore.initUser();
        }
        const fetchFriends = async() =>{
            await userStore.getFriends();
        }
        fetchGameInfo();
        fetchData();
        fetchFriends();

    }, []);

    if (userStore.loadingUser) return <Loading/>

    return (
        <div className='profile-page'>
            <div className="container">

                <ProfileUserWidget/>
                <ProfileFriendWidget/>
                <ProfileStatisticWidget/>
                <ProfileGoldPuckWidget/>

                <Link
                    to='https://fon.bet/?deepLink=%7B%22alias%22%3A%22externalLink%22%2C%22urlAlias%22%3A%22ovi8%22%7D&sysId=24'><img
                    src={FonbetNew} alt="fb" style={{width: '100%', marginTop: 20}}/></Link>

            </div>
        </div>
    );
};
